export const AccountTypes = {
  REGISTERED: 'REGISTERED',
  LINKED: 'LINKED',
};
